import api from '../api';

const path = '/company';

export const addCompanyRequest = (values) => api.post(`${path}/add`, values);
export const getCompanyRequest = (id) => api.get(`${path}/get/${id}`);
export const getCompanyListRequest = () => api.get(`${path}/get`);
export const deleteCompanyRequest = (id) => api.delete(`${path}/delete/${id}`);
export const editCompanyRequest = (updates) =>
    api.put(`${path}/edit/${updates.id}`, {
        updates,
    });

export const getAdvertsListRequest = (params) =>
    api.get(`${path}/adverts/get`, { params });
